import { Slice } from "./favouriteDashboardSearchSlice";

const { actions } = Slice;

export const SetCurrentTabIndex = (queryParams: any) => (
  dispatch: (arg0: { payload: any; type: string }) => void
) => {
  // dispatch(actions.startCall({ callType: callTypes.list }));
  return dispatch(actions.CurrentTabIndexSet(queryParams));
};
